import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
		fill: "#ffffff",
		fillOpacity: 0,
		width: 17.12,
		height: 17.12,
		x: .44,
		y: .44,
		stroke: "#BCC6D0",
		strokeWidth: .88,
		rx: 3.52
	}), /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		d: "M9.745 8.208H13v1.32H9.745V13h-1.49V9.528H5v-1.32h3.255V5h1.49z"
	})] })
});
export default SvgPlus;
